var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIc2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    height: 20,
    viewBox: "0 0 32 20",
    width: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1313_929)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    height: 20,
    rx: 2,
    width: 32
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M26.1701 8.00875C27.0412 8.00875 27.5203 8.4117 27.5203 9.17283C27.5638 9.75487 27.1718 10.2474 26.6492 10.3369L27.8251 11.9935H26.9105L25.9088 10.3817H25.8217V11.9935H25.0812V8.00875H26.1701ZM25.8215 9.84456H26.0393C26.5183 9.84456 26.7361 9.62069 26.7361 9.21774C26.7361 8.85956 26.5183 8.6357 26.0393 8.6357H25.8215V9.84456ZM22.5109 11.9935H24.6015V11.322H23.2514V10.2474H24.558V9.57578H23.2514V8.68033H24.6015V8.00875H22.5109V11.9935ZM20.3338 10.6951L19.332 8.00875H18.548L20.1595 12.0831H20.5515L22.163 8.00875H21.3791L20.3338 10.6951ZM11.4924 10.0236C11.4924 11.1429 12.3635 12.0831 13.4523 12.0831C13.8007 12.0831 14.1056 11.9936 14.4105 11.8593V10.9638C14.1927 11.2325 13.8878 11.4116 13.5394 11.4116C12.8426 11.4116 12.2764 10.8743 12.2764 10.1579V10.0683C12.2328 9.35197 12.799 8.72515 13.4959 8.68038C13.8443 8.68038 14.1927 8.85947 14.4105 9.12811V8.23266C14.1492 8.05357 13.8007 8.0088 13.4959 8.0088C12.3635 7.91925 11.4924 8.85947 11.4924 10.0236ZM10.1422 9.53159C9.70656 9.3525 9.57592 9.26295 9.57592 9.03909C9.61947 8.77046 9.83726 8.54659 10.0986 8.59137C10.3164 8.59137 10.5341 8.72568 10.7084 8.90477L11.1003 8.3675C10.7955 8.09887 10.4035 7.91978 10.0115 7.91978C9.40171 7.87501 8.87906 8.3675 8.8355 8.99432V9.03909C8.8355 9.57636 9.05327 9.88977 9.75016 10.1136C9.92436 10.1584 10.0986 10.248 10.2728 10.3375C10.4035 10.4271 10.4906 10.5614 10.4906 10.7405C10.4906 11.0539 10.2293 11.3225 9.96786 11.3225H9.92436C9.57592 11.3225 9.27104 11.0987 9.14038 10.7853L8.66129 11.2778C8.92261 11.7703 9.44526 12.0389 9.96786 12.0389C10.6648 12.0837 11.231 11.5464 11.2746 10.83V10.6957C11.231 10.1584 11.0132 9.88977 10.1422 9.53159ZM7.61539 11.9935H8.35581V8.00875H7.61539V11.9935ZM4.17496 8.00875H5.26381H5.48158C6.52687 8.05352 7.3544 8.94897 7.31084 10.0235C7.31084 10.6056 7.04952 11.1429 6.61398 11.5458C6.22199 11.8592 5.7429 12.0383 5.26381 11.9935H4.17496V8.00875ZM5.13296 11.3211C5.4814 11.3658 5.87338 11.2315 6.1347 11.0077C6.39603 10.739 6.52669 10.3808 6.52669 9.97784C6.52669 9.61966 6.39603 9.26148 6.1347 8.99284C5.87338 8.76898 5.4814 8.63466 5.13296 8.67943H4.91519V11.3211H5.13296Z",
    fill: "black",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M16.6316 7.91695C15.5428 7.91695 14.6281 8.8124 14.6281 9.97648C14.6281 11.0958 15.4992 12.0361 16.6316 12.0808C17.764 12.1256 18.6351 11.1854 18.6786 10.0213C18.6351 8.85717 17.764 7.91695 16.6316 7.91695Z",
    fill: "#FD6020",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 20.5L31.85 15V19C31.85 19.8284 31.1785 20.5 30.35 20.5H14Z",
    fill: "#FD6020"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    height: 19.5,
    rx: 1.75,
    stroke: "black",
    strokeWidth: 0.5,
    width: 31.5,
    x: 0.25,
    y: 0.25
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1313_929"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    height: 20,
    rx: 2,
    width: 32
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIc2);
export default __webpack_public_path__ + "static/media/ic2.f70a127f156bfdca3744263f7eacd6eb.svg";
export { ForwardRef as ReactComponent };